import { Text } from '@components/text';

export type FieldDescriptionProps = {
  text?: string;
};

export const FieldDescription = ({ text }: FieldDescriptionProps) => {
  if (!text) return null;
  return <Text font="regular14" color="textHelper" text={text} />;
};
